import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, Modal, message, Spin, Radio, Alert, Checkbox, Tooltip } from 'antd';
import { CheckCircleOutlined, DownloadOutlined, WhatsAppOutlined, WarningOutlined, InfoCircleOutlined, QuestionCircleOutlined, BulbOutlined } from '@ant-design/icons';
import Ciudades from '../../ciudades/ciudades';
import axios from 'axios';
import './SendClientCart.css';
import './SendClientCartCopy.css';

const { Option } = Select;

const calcularPrecioConComision = (precio) => {
  const precioBase = parseFloat(precio);
  const comision = parseFloat(localStorage.getItem('porcentaje_comision')) || 0;
  const comisionDecimal = comision / 100;
  return precioBase + (precioBase * comisionDecimal);
};

const SendClientCart = ({ cart: initialCart, onOrderSuccess, setMostrarEnviosCarrito }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [transportadora, setTransportadora] = useState(0);
  const [cotizaciones, setCotizaciones] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [orderResponse, setOrderResponse] = useState(null);
  const [idsucursal, setIdsucursal] = useState('');
  const [statusWhatsapp, setStatusWhatsapp] = useState(false);
  const [originCityCode, setOriginCityCode] = useState('');
  const [seguro99Enabled, setSeguro99Enabled] = useState(true);
  const [cart, setCart] = useState(
    initialCart.map(item => ({
      ...item,
      suggestedPrice: calcularPrecioConComision(item.suggestedPrice)
    }))
  );
  const [modalMessage, setModalMessage] = useState(null);
  const [cartGroups, setCartGroups] = useState([]);

  // Agrupar productos por sucursal
  useEffect(() => {
    const groups = cart.reduce((acc, item) => {
      const sucursalId = item.sucursal_id;
      if (!acc[sucursalId]) {
        acc[sucursalId] = [];
      }
      acc[sucursalId].push(item);
      return acc;
    }, {});
    
    setCartGroups(Object.entries(groups).map(([sucursalId, items]) => ({
      sucursalId,
      items
    })));
  }, [cart]);
  const [selectedVariations, setSelectedVariations] = useState({}); // Nuevo estado para variaciones seleccionadas

  const fetchModalMessage = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/modals');
      if (response.data && response.data.activo) {
        setModalMessage(response.data);
      }
    } catch (error) {
      console.error('Error al obtener el mensaje del modal', error);
    }
  };

  useEffect(() => {
    fetchModalMessage();
  }, []);

  const usuario_id = localStorage.getItem('usuario_id');

  // Añadir useEffect para obtener el ID de sucursal
  useEffect(() => {
    const fetchSucursalId = async () => {
      try {
        const response = await axios.get(`https://99envios.app/api/online/sucursal-codigo-sucursal/${usuario_id}`);
        setIdsucursal(response.data);
      } catch (error) {
        console.error('Error al obtener el ID de la sucursal', error);
      }
    };

    if (usuario_id) {
      fetchSucursalId();
    }
  }, [usuario_id]);

 

  // Verificar si Ciudades está disponible
  useEffect(() => {
    if (!Array.isArray(Ciudades) || Ciudades.length === 0) {
      console.error('Error: La lista de ciudades no está disponible o está vacía');
    }
  }, []);

  // Calcular subtotal del carrito con comisión
  const subtotal = cart.reduce((total, item) => total + (item.suggestedPrice * item.quantity), 0);

  const images = [
    '/Images/coordi.png',
    '/Images/inter.png',
    '/Images/servi.png',
    '/Images/tcc.svg'
  ];

  const envios = [
    'coordinadora',
    'interrapidisimo',
    'servientrega',
    'tcc'
  ];

  const actualizarPrecioTransportadora = (index) => {
    const transportadoraName = envios[index];
    const cotizacion = cotizaciones[transportadoraName];
    if (cotizacion) {
      // Reiniciamos el total y calculamos todo desde cero
      let total = 0;
      total += cotizacion.valor || 0;
      total += cotizacion.valor_contrapago || 0;
      total += cotizacion.comision_interna || cotizacion.valor_interna || 0;
      total += cotizacion.sobreflete || 0;
      // Solo agregamos el seguro99 si está habilitado
      if (seguro99Enabled) {
        total += cotizacion.seguro99 || 0;
      }
      setTransportadora(total);
    }
  };

  const handleImageClick = (index) => {
    setSelectedImage(index);
    actualizarPrecioTransportadora(index);
  };

  const handleSeguro99Change = (checked) => {
    if (!checked) {
      Modal.warning({
        title: (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            color: '#d48806',
            fontSize: '16px',
            fontWeight: '500'
          }}>
            <WarningOutlined />
            Sin Seguro 99
          </div>
        ),
        content: (
          <div style={{ 
            padding: '16px',
            background: '#fffbe6',
            borderRadius: '8px',
            border: '1px solid #ffe58f'
          }}>              <div style={{ 
                padding: '20px',
                color: '#666',
                textAlign: 'center',
                fontSize: '14px'
              }}>
                Al desactivar esta opción, deberás asumir el costo del envío de ida en caso de que el pedido sea devuelto.
              </div>
            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: '#fff',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#1890ff'
            }}>
              <BulbOutlined />
              <div>
                <strong>Recomendación:</strong> Mantén activo el Seguro 99 para proteger el costo de tu envío en caso de devolución.
                <div style={{ fontSize: '12px', marginTop: '4px', color: '#666' }}>
                  Nota: Este seguro solo cubre el valor del envío, no el valor del producto.
                </div>
              </div>
            </div>
          </div>
        ),
        okText: 'Entendido',
        okButtonProps: { 
          style: { 
            backgroundColor: '#d48806',
            borderColor: '#d48806',
            borderRadius: '6px',
            height: '36px',
            fontWeight: '500',
            boxShadow: '0 2px 0 rgba(0,0,0,0.043)'
          } 
        },
        maskClosable: true,
        centered: true,
        width: 480,
        className: 'seguro99-warning-modal'
      });
    }
    setSeguro99Enabled(checked);
    
    // Actualizar el precio de la transportadora si hay una seleccionada
    if (selectedImage !== null) {
      actualizarPrecioTransportadora(selectedImage);
    }
  };

  const handleCotizar = async () => {
    try {
      const values = await form.validateFields(['city']);
      setLoading(true);
      
      const firstItem = cart[0];
      if (!firstItem?.origin_city_id) {
        message.error('No se encontró el código de ciudad de origen');
        setLoading(false);
        return;
      }

      const current = new Date();
      const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                           ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                           current.getFullYear();

      const response = await axios.post(
        `https://integration.99envios.app/api/sucursal/cotizar/${idsucursal}`,
        {
          destino: { nombre: "", codigo: values.city },
          origen: { nombre: "", codigo: firstItem.origin_city_id },
          IdTipoEntrega: 1,
          IdServicio: 1,
          peso: cart.reduce((total, item) => total + 1, 0),
          largo: 1,
          ancho: 1,
          alto: 1,
          fecha: formattedDate,
          AplicaContrapago: true,
          valorDeclarado: subtotal,
          seguro99: seguro99Enabled,
        }
      );
      
      setCotizaciones(response.data);
      message.success('Cotización generada con éxito');

      // Actualizar el precio de la transportadora si hay una seleccionada
      if (selectedImage !== null) {
        actualizarPrecioTransportadora(selectedImage);
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al generar la cotización');
    } finally {
      setLoading(false);
    }
  };

  // Método modificado para validar stock al cambiar cantidad
  const handleQuantityChange = (productId, newQuantity, stock) => {
    if (newQuantity < 1) {
      message.error('La cantidad debe ser al menos 1');
      return;
    }
    if (newQuantity > stock) {
      message.error(`Solo hay ${stock} unidades disponibles`);
      return;
    }
    
    setCart(prevCart =>
      prevCart.map(item =>
        item.id === productId 
          ? { ...item, quantity: parseInt(newQuantity) }
          : item
      )
    );
  };

  // Nuevo método para actualizar precio
  const handlePriceChange = (productId, newPrice) => {
    if (newPrice < 0) {
      message.error('El precio no puede ser negativo');
      return;
    }
    
    setCart(prevCart =>
      prevCart.map(item =>
        item.id === productId
          ? { ...item, suggestedPrice: parseFloat(newPrice) }
          : item
      )
    );
  };

  // Nuevo método para manejar cambio de variación
  const handleVariationChange = (productId, value) => {
    setSelectedVariations(prev => ({ ...prev, [productId]: value }));
  };

  // Método modificado para confirmar pedido con validación de stock
  const handleConfirmar = async () => {
    if (selectedImage === null) {
      message.error('Por favor seleccione una transportadora');
      return;
    }

    try {
      const values = await form.validateFields();
      setLoading(true);
      
      const completedOrders = [];

      // Procesar cada grupo de productos por sucursal
      for (const group of cartGroups) {
        const orderData = {
          productos: group.items.map(item => {
            const comisionPorcentaje = parseFloat(localStorage.getItem('porcentaje_comision')) || 0;
            const comision = (item.supplierPrice * comisionPorcentaje) / 100;
            
            return {
              IdProducto: item.id,
              IdVariacion: item.variationId || selectedVariations[item.id] || '', // Añadir variación seleccionada
              valorDeclarado: item.suggestedPrice * item.quantity,
              Cantidad: item.quantity,
              comision: comision
            };
          }),
          AplicaContrapago: true,
          valorFlete: transportadora / cartGroups.length,
          Destinatario: {
            nombre: values.firstName,
            primerApellido: values.lastName.split(' ')[0] || '',
            segundoApellido: values.lastName.split(' ')[1] || '',
            telefono: values.phone,
            direccion: values.address,
            idLocalidad: values.city,
            correo: values.email
          },
          Observaciones: values.notes,
          transportadora: {
            pais: 'colombia',
            nombre: envios[selectedImage]
          },
          seguro99: seguro99Enabled,
        };

        const token = localStorage.getItem('token');
        const config = {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        };

        try {
          const response = await axios.post(
            `https://99envios.app/api/solicitud-orden/${usuario_id}`,
            orderData,
            config
          );

          if (response.status === 201 && response.data) {
            completedOrders.push({
              sucursalId: group.sucursalId,
              orderResponse: response.data
            });
          }

          // Consolidar todas las órdenes confirmadas en un modal
          if (completedOrders.length > 0) {
            setOrderResponse({
              completedOrders,
              totalOrders: cartGroups.length
            });
            setIsModalVisible(true);
          }
        } catch (error) {
          console.error(`Error al procesar orden para sucursal ${group.sucursalId}:`, error);
          message.error(`Error al procesar orden para sucursal ${group.sucursalId}`);
        }
      }

    } catch (error) {
      console.error('Error al procesar los pedidos:', error);
      message.error('Error al procesar los pedidos');
    } finally {
      setLoading(false);
    }
  };

  // Funciones de formateo
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  // Calcular valores totales
  const totalProveedor = cart.reduce((total, item) => total + (calcularPrecioConComision(item.supplierPrice) * item.quantity), 0);
  const precioEnvioActual = selectedImage !== null && cotizaciones[envios[selectedImage]] ? (() => {
    const cotizacion = cotizaciones[envios[selectedImage]];
    let total = 0;
    total += cotizacion.valor || 0;
    total += cotizacion.valor_contrapago || 0;
    total += cotizacion.comision_interna || cotizacion.valor_interna || 0;
    total += cotizacion.sobreflete || 0;
    if (seguro99Enabled) {
      total += cotizacion.seguro99 || 0;
    }
    return total;
  })() : 0;
  const montoGanar = subtotal - totalProveedor - precioEnvioActual;
  const totalFinal = subtotal;

  return (
    <Spin spinning={loading}>
        <div className="modal-carrito">
          <div className="formulario-carrito">
            <h3 className="titulo-productos-carrito">Datos del Destinatario</h3>
            <Form form={form} layout="vertical" className="contenido-formulario-carrito">
              <Form.Item
                name="firstName"
                label="Nombre(s)"
                rules={[{ required: true, message: 'Campo requerido' }]}
                className="campo-formulario-carrito"
              >
                <Input placeholder="Nombre del destinatario" />
              </Form.Item>

              <Form.Item
                name="lastName"
                label="Apellido(s)"
                rules={[{ required: true, message: 'Campo requerido' }]}
                className="campo-formulario-carrito"
              >
                <Input placeholder="Apellidos del destinatario" />
              </Form.Item>

              <Form.Item
                name="phone"
                label="Teléfono"
                rules={[{ required: true, message: 'Campo requerido' }]}
                className="campo-formulario-carrito"
              >
                <Input placeholder="Número de teléfono" />
              </Form.Item>

              <Form.Item
                name="email"
                label="Email"
                rules={[{ type: 'email', message: 'Email inválido' }]}
                className="campo-formulario-carrito"
              >
                <Input placeholder="Correo electrónico" />
              </Form.Item>

              <Form.Item
                name="address"
                label="Dirección"
                rules={[{ required: true, message: 'Campo requerido' }]}
                className="campo-formulario-carrito"
              >
                <Input.TextArea placeholder="Dirección completa" />
              </Form.Item>

              <Form.Item
                name="city"
                label="Ciudad"
                rules={[{ required: true, message: 'Seleccione una ciudad' }]}
                className="campo-formulario-carrito"
              >
                <Select
                  showSearch
                  placeholder="Seleccione una ciudad"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                >
                  {Array.isArray(Ciudades) && Ciudades.map(ciudad => (
                    <Option key={ciudad.value} value={ciudad.value}>
                      {ciudad.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="notes"
                label="Notas"
                rules={[{ required: true, message: 'Campo requerido' }]}
                className="campo-formulario-carrito"
              >
                <Input.TextArea placeholder="Notas para el envío" />
              </Form.Item>

              <Button type="primary" onClick={handleCotizar} block>
                Cotizar Envío
              </Button>
            </Form>
          </div>

          <div className="transportadoras-carrito">
            <h3 className="titulo-productos-carrito">Transportadoras</h3>
            {/* {modalMessage && modalMessage.activo && (
              <Alert 
                message={modalMessage.mensaje} 
                type="info" 
                closable 
                style={{ marginBottom: '16px' }}
              />
            )} */}
            <div className="seguro99-container">
              <Checkbox
                checked={seguro99Enabled}
                onChange={(e) => handleSeguro99Change(e.target.checked)}
              >
                SEGURO 99
                <Tooltip 
                  title={
                    <div style={{ fontSize: '13px', lineHeight: '1.5' }}>
                      <p style={{ marginBottom: '8px' }}>
                        🛡️ <strong>Seguro de Costos de Envío</strong>
                      </p>
                      <p style={{ marginBottom: '8px' }}>
                        Si el envío es devuelto por cualquiera de estas razones, te reembolsamos el costo del envío:
                      </p>
                      <ul style={{ paddingLeft: '16px', marginTop: '4px', marginBottom: '8px' }}>
                        <li>No entrega al destinatario</li>
                        <li>Rechazo del paquete</li>
                        <li>Falta de pago</li>
                      </ul>
                      <div style={{ fontSize: '12px', color: '#666', borderTop: '1px solid #eee', paddingTop: '8px', marginTop: '8px' }}>
                        <p style={{ marginBottom: '4px' }}><strong>Importante:</strong></p>
                        <ul style={{ paddingLeft: '16px', margin: '4px 0' }}>
                          <li>Este seguro solo cubre el costo del envío. No cubre el valor del producto.</li>
                          <li>En caso de devolución, deberás asumir el costo del envío inicial.</li>
                        </ul>
                      </div>
                    </div>
                  }
                  placement="right"
                >
                  <QuestionCircleOutlined className="info-icon" />
                </Tooltip>
              </Checkbox>
            </div>
            <div className="contenedor-transportadoras-carrito">
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`opcion-transportadora-carrito ${
                    selectedImage === index ? 'opcion-transportadora-seleccionada-carrito' : ''
                  }`}
                  onClick={() => handleImageClick(index)}
                >
                  <img src={image} alt={`Transportadora ${index + 1}`} />
                  <div className="precio-transportadora-carrito">
                    {cotizaciones[envios[index]] ? (
                      formatCurrency((() => {
                        const cotizacion = cotizaciones[envios[index]];
                        let total = 0;
                        total += cotizacion.valor || 0;
                        total += cotizacion.valor_contrapago || 0;
                        total += cotizacion.comision_interna || cotizacion.valor_interna || 0;
                        total += cotizacion.sobreflete || 0;
                        if (seguro99Enabled) {
                          total += cotizacion.seguro99 || 0;
                        }
                        return total;
                      })())
                    ) : (
                      <span className="sin-cotizacion-carrito"></span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="detalles-carrito">
            <div className="resumen-productos-carrito">
              <h3 className="titulo-productos-carrito">Información del Pedido</h3>
              <div className="lista-productos">
                {cart.map(item => (
                  <div key={item.id} className="item-producto-carrito">
                    <div className="cabecera-producto-carrito">
                      <h4>{item.name}</h4>
                      <span className="referencia-producto-carrito">REF: {item.id}</span>
                    </div>
                    <div className="detalles-producto-carrito">
                      <div className="fila-detalles-carrito">
                        {item.variaciones?.length > 0 && (
                        <div className="grupo-detalles-carrito">
                          <label>Variación:</label>
                          <Select
                            placeholder="Selecciona variación"
                            value={selectedVariations[item.id]}
                            onChange={val => handleVariationChange(item.id, val)}
                          >
                            {item.variaciones.map(v => (
                              <Option key={v.id} value={v.id}>
                                {`${v.talla} / ${v.color} (Stock: ${v.cantidad_disponible})`}
                              </Option>
                            ))}
                          </Select>
                        </div>
                      )}
                      <div className="grupo-detalles-carrito">
                          <label>Precio sugerido</label>
                          <Input
                            type="number"
                            value={item.suggestedPrice}
                            onChange={(e) => handlePriceChange(item.id, e.target.value)}
                            min={0}
                            style={{ fontSize: '1rem', height: '40px' }}
                          />
                        </div>
                        <div className="grupo-detalles-carrito">
                          <label>Cantidad</label>
                          <div className="grupo-cantidad-stock-carrito">
                            <Input
                              type="number"
                              value={item.quantity}
                              onChange={(e) => handleQuantityChange(item.id, e.target.value, item.stock)}
                              min={1}
                              max={item.stock}
                              style={{ fontSize: '1rem', height: '40px' }}
                            />
                            <span className={`indicador-stock-carrito ${item.quantity > item.stock ? 'error-carrito' : 'exito-carrito'}`}>
                              {item.stock} disponibles
                            </span>
                          </div>
                        </div>
                        <div className="grupo-detalles-carrito">
                          <label>Precio proveedor</label>
                          <div style={{ 
                            padding: '8px 12px', 
                            background: '#f8f9fa', 
                            borderRadius: '8px',
                            border: '2px solid #e8e8e8',
                            fontSize: '1rem',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            {formatCurrency(calcularPrecioConComision(item.supplierPrice))}
                          </div>
                        </div>
                      </div>
                      <div className="fila-subtotal-carrito">
                        <span>Subtotal:</span>
                        <span className="valor-subtotal-carrito">{formatCurrency(item.suggestedPrice * item.quantity)}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="resumen-orden-carrito">
              <div className="linea-total-carrito">
                <span>Sub Total</span>
                <div className="monto-total-carrito">{formatCurrency(subtotal)}</div>
              </div>

              <div className="linea-total-carrito">
                <span>Precio Proveedor</span>
                <div className="monto-total-carrito">{formatCurrency(totalProveedor)}</div>
              </div>

              <div className="linea-total-carrito">
                <span>Precio de Envío</span>
                <div className="monto-total-carrito">
                  {selectedImage !== null && cotizaciones[envios[selectedImage]] ? 
                    formatCurrency((() => {
                      const cotizacion = cotizaciones[envios[selectedImage]];
                      let total = 0;
                      total += cotizacion.valor || 0;
                      total += cotizacion.valor_contrapago || 0;
                      total += cotizacion.comision_interna || cotizacion.valor_interna || 0;
                      total += cotizacion.sobreflete || 0;
                      if (seguro99Enabled) {
                        total += cotizacion.seguro99 || 0;
                      }
                      return total;
                    })()) : 
                    formatCurrency(0)
                  }
                </div>
              </div>

              <div className="linea-total-carrito">
                <span>Comisión de la plataforma</span>
                <div className="monto-total-carrito">{formatCurrency(0)}</div>
              </div>

              <div className="linea-total-carrito" style={{ marginTop: '8px' }}>
                <span>Monto a ganar cuando esté entregado</span>
                <div className="monto-total-carrito" style={{ 
                  color: montoGanar < 0 ? '#ff4d4f' : '#52c41a',
                  fontSize: '1.1em'
                }}>
                  {formatCurrency(montoGanar)}
                </div>
              </div>

              {montoGanar < 0 && (
                <div className="warning-message">
                  ⚠️ El monto a ganar es negativo. Revisa los precios antes de confirmar.
                </div>
              )}

              <div className="total-final-carrito">
                <div>Total a cobrar al cliente:</div>
                <span className="monto-total-carrito gran-total-carrito">
                  {formatCurrency(totalFinal)}
                </span>
              </div>
              
              <Button 
                type="primary" 
                onClick={handleConfirmar}
                disabled={selectedImage === null || montoGanar < 0}
                size="large"
                block
                style={{ 
                  marginTop: '24px',
                  height: '48px',
                  fontSize: '1.1em',
                  borderRadius: '8px'
                }}
              >
                {selectedImage === null ? 'Seleccione una transportadora' : 'Confirmar Pedido'}
              </Button>
            </div>
          </div>
        </div>

        <Modal
          title={<span><CheckCircleOutlined style={{ color: 'green' }} /> Pedido Confirmado</span>}
          visible={isModalVisible}
          onCancel={null}
          maskClosable={false}
          keyboard={false}
          closable={false}
          footer={[
            <Button
              key="cerrar"
              onClick={() => {
                setIsModalVisible(false);
                if (onOrderSuccess) onOrderSuccess();
              }}
            >
              Cerrar
            </Button>,
            <Button
              key="pdf"
              type="primary"
              onClick={() => orderResponse?.pdf && window.open(orderResponse.pdf, '_blank')}
              disabled={!orderResponse?.pdf}
            >
              Ver Guía
            </Button>
          ]}
        >
          {orderResponse && (
            <div className="confirmacion-pedido-carrito">
              <div className="cabecera-confirmacion-carrito">
                <h2>¡Pedido Confirmado!</h2>
                <p>{orderResponse.completedOrders[0]?.orderResponse.error}</p>
                <p>ID de Solicitud: {orderResponse.completedOrders[0]?.orderResponse.id_solicitud}</p>
                <p>Estado: {orderResponse.completedOrders[0]?.orderResponse.estado}</p>
              </div>
            </div>
          )}
        </Modal>
    </Spin>
  );
};

export default SendClientCart;
